import http from 'api/httpClient';

export type Permission = {
  perm_key: string;
  perm_desc: string;
  allowed: boolean;
};

export type AccessLevel = {
  id: number;
  name: string;
};

export type Role = {
  role_id: number;
  role_name: string;
  access_level_id: number | null;
  access_level_name: string;
  permissions: Permission[];
};

export type ListRolesResponse = {
  total: number;
  items: Role[];
};

export type CreateRoleRequest = {
  role_name: string;
  access_level_id: number | null;
  permissions: Record<string, boolean>;
};

export type UpdateRoleRequest = {
  role_name?: string;
  access_level_id?: number | null;
  permissions?: Record<string, boolean>;
};

export async function listRoles(): Promise<ListRolesResponse> {
  return http.get('/api/v1/roles');
}

export async function createRole(payload: CreateRoleRequest): Promise<Role> {
  return http.post('/api/v1/roles', payload);
}

export async function updateRole(roleId: number, payload: UpdateRoleRequest): Promise<Role> {
  return http.patch(`/api/v1/roles/${roleId}`, payload);
}

export async function listAccessLevels(): Promise<AccessLevel[]> {
  return http.get('/api/v1/levels');
}

export const getRoleMenus = async (roleId: string) => {
  try {
    const response = await http.get(`/api/v1/menu/all/${roleId}`);
    return response;
  } catch (error) {
    console.error('Error fetching role menus:', error);
    throw error;
  }
};

export const toggleRoleMenuAccess = async (roleId: string, menuId: string) => {
  try {
    const response = await http.patch(`/api/v1/roles/${roleId}/menu/${menuId}`);
    return response;
  } catch (error) {
    console.error('Error toggling role menu access:', error);
    throw error;
  }
};